<div class="monitor-dashboard-page-shell monitor-dashboard-page-section monitor-dashboard-requests">
  <div class="mb-4">
    <h2 class="mb-0 font-weight-bold monitor-dashboard-title">
      {{$t('monitorDashboard.requestsDashboard')}}
    </h2>
  </div>

  <div class="mb-4">
    <v-tabs v-model="requestsTab" background-color="transparent" color="primary" slider-color="primary"
      class="monitor-dashboard-subtabs">
      <v-tab class="text-none font-weight-bold">
        {{$t('monitorDashboard.overview')}}
      </v-tab>
      <v-tab class="text-none font-weight-bold">
        {{$t('monitorDashboard.senderNames')}}
      </v-tab>
    </v-tabs>
  </div>

  <div class="mb-4">
    <div class="monitor-dashboard-filters-wrapper">
      <div class="monitor-dashboard-filters-grid"
        :class="{ 'monitor-dashboard-filters-grid-senders': requestsTab === 1 }">

        <div class="monitor-dashboard-filter-item monitor-dashboard-filter-item-date">
          <div class="monitor-dashboard-filter-title">{{$t('monitorDashboard.createdDate')}}</div>
          <vc-date-picker v-model="createdDateRangeInternal" :model-config="createdDateModelConfig"
            :min-date="launchDate" :max-date="todayStr" is-range color="gray"
            :popover="{ placement: 'bottom-start' }">
            <template v-slot="{ togglePopover }">
              <v-text-field :value="dateRangeText" append-icon="event" dense hide-details solo flat
                readonly class="monitor-dashboard-filter-control monitor-dashboard-date-control"
                @click.native="togglePopover()" />
            </template>
          </vc-date-picker>
        </div>

        <div v-if="requestsTab === 0" class="monitor-dashboard-filter-item">
          <div class="monitor-dashboard-filter-title">{{$t('monitorDashboard.requestType')}}</div>
          <v-select v-model="draftChartFilter.requestType" :items="requestTypes" item-text="name"
            item-value="id" dense hide-details solo attach :menu-props="monitorDashboardSelectMenuProps"
            class="monitor-dashboard-filter-control" />
        </div>

        <div class="monitor-dashboard-filter-item">
          <div class="monitor-dashboard-filter-title">{{$t('monitorDashboard.customerType')}}</div>
          <v-select v-model="draftChartFilter.customerType" :items="customerTypes" item-text="name"
            item-value="id" dense hide-details solo attach :menu-props="monitorDashboardSelectMenuProps"
            class="monitor-dashboard-filter-control" />
        </div>

        <div class="monitor-dashboard-filter-item">
          <div class="monitor-dashboard-filter-title">{{$t('monitorDashboard.smsServiceProvider')}}</div>
          <v-select v-model="draftChartFilter.providerId" :items="providers" item-text="name"
            item-value="id" dense hide-details solo attach :menu-props="monitorDashboardSelectMenuProps"
            class="monitor-dashboard-filter-control monitor-dashboard-filter-control--provider" />
        </div>

        <div class="monitor-dashboard-filter-item">
          <div class="monitor-dashboard-filter-title">{{$t('monitorDashboard.serviceProvider')}}</div>
          <v-select v-model="draftChartFilter.tenant" :items="tenants" item-text="name" item-value="id"
            dense hide-details solo attach :menu-props="monitorDashboardSelectMenuProps"
            class="monitor-dashboard-filter-control" />
        </div>

        <div class="monitor-dashboard-filter-button-item monitor-dashboard-filter-button-item-shrink">
          <div class="monitor-dashboard-filter-title monitor-dashboard-filter-title-placeholder"></div>
          <button class="btn btn-primary btn-action monitor-dashboard-filter-button"
            type="button"
            :disabled="isDraftDateRangeInvalid"
            :aria-invalid="isDraftDateRangeInvalid ? 'true' : 'false'"
            @click="applyFilters">
            {{$t('shared.apply')}}
          </button>
        </div>

        <div class="monitor-dashboard-filter-button-item monitor-dashboard-filter-button-item-shrink">
          <div class="monitor-dashboard-filter-title monitor-dashboard-filter-title-placeholder"></div>
          <button class="btn btn-primary btn-action monitor-dashboard-filter-button"
            @click="resetFilters">
            {{$t('shared.reset')}}
          </button>
        </div>

      </div>
    </div>
    <div v-if="isDraftDateRangeInvalid" class="small text-danger mt-2 px-1" role="alert">
      {{ $t('monitorDashboard.invalidDateRange') }}
    </div>
  </div>

  <v-tabs-items v-model="requestsTab" class="transparent-tabs-items">
    <v-tab-item>
      <div class="monitor-dashboard-tab-panel">
        <requests-overview-page v-if="requestsTab === 0" ref="overviewPage" :filter="overviewChartFilter"
          :tenants="tenants">
        </requests-overview-page>
      </div>
    </v-tab-item>

    <v-tab-item>
      <div class="monitor-dashboard-tab-panel">
        <requests-senders-page v-if="requestsTab === 1" ref="sendersPage" :filter="sendersChartFilter"
          :tenants="tenants">
        </requests-senders-page>
      </div>
    </v-tab-item>
  </v-tabs-items>
</div>
